import type { ProgramEventInviteeRole, ProgramUserRsvp } from 'models';
import { Col, Form, Modal, Row, Select, TextInput } from 'ui';
import { useEventInviteesRoleFilterOptions, useEventInviteesStatusFilterOptions } from './hooks';

export type EventInviteesFiltersFormValues = {
  role?: 'all' | ProgramEventInviteeRole;
  search?: string;
  status?: 'all' | ProgramUserRsvp;
};

const EventInviteesFilters = () => {
  const inviteesStatusOptions = useEventInviteesStatusFilterOptions();
  const inviteesRoleOptions = useEventInviteesRoleFilterOptions();

  return (
    <Modal.ScrollableContent.Header>
      <Row className="event-invitees-filters" gutter="ms">
        <Col span={8}>
          <TextInput
            hasSearch
            item={{
              label: 'Search',
              name: 'search',
              noOptional: true,
            }}
          />
        </Col>
        <Col span={8}>
          <Form.Item<EventInviteesFiltersFormValues> label="Role" name="role" noOptional>
            <Select options={inviteesRoleOptions} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<EventInviteesFiltersFormValues> label="Status" name="status" noOptional>
            <Select options={inviteesStatusOptions} />
          </Form.Item>
        </Col>
      </Row>
    </Modal.ScrollableContent.Header>
  );
};

export default EventInviteesFilters;
